import { OnInit, Component } from '@angular/core';
import { CaseLawyerPaymentLineEditableComponent } from '../editable/case-lawyer-payment-line-editable.component';

@Component({
    selector: '[case-lawyer-payment-line-readonly]',
    templateUrl: './case-lawyer-payment-line-readonly.component.html',
    styleUrls: ['./case-lawyer-payment-line-readonly.component.scss']
})
export class CaseLawyerPaymentLineReadonlyComponent extends CaseLawyerPaymentLineEditableComponent implements OnInit {

    public ngOnInit() {
        super.ngOnInit();
    }
}
